export default "__VITE_ASSET__cda1b0d7__"